<template>
  <!-- 优惠券管理-优惠券配置 -->
  <div class="coupon-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" class="demo-form-inline">
        <el-form-item>
          <el-button type="primary" @click="openDialog(1)"
            >添加优惠券</el-button
          >
        </el-form-item>
      </el-form>
    </header>
    <!-- name: '',//优惠券名称
      preferential_type: 1,//优惠途径 1是充值 2商城
    reduction_type: 1,//折扣类型 1是百分比 2是固定金额
    reduction_way: 1,//优惠方式 1折扣 2是赠送
    status: 1,//优惠券状态 1是正常 2是关闭
    operation_amount: '',//花费金额
    reduction_number: '',//比例或者金额 -->
    <!-- body内容 -->
    <div class="body-box">
      <el-table
        :data="dataList"
        v-loading="loading"
        style="margin-bottom: 20px"
      >
        <el-table-column prop="id" label="ID" align="center"> </el-table-column>
        <el-table-column prop="name" label="名称" align="center">
        </el-table-column>
        <el-table-column
          prop="operation_amount"
          label="用券详情"
          align="center"
        >
          <template slot-scope="{ row }">
            <span>
              {{ row.preferential_type == 1 ? "充值" : "购买" }}
              {{ row.operation_amount }}
              {{ row.reduction_way == 1 ? "折扣" : "赠送" }}
              {{
                row.reduction_type == 1
                  ? row.reduction_number + "%"
                  : row.reduction_number
              }}
            </span>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="count" label="人数" align="center">
        </el-table-column> -->
        <el-table-column prop="days" label="失效天数" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag type="success" v-if="row.status === 1">正常</el-tag>
            <el-tag type="danger" v-if="row.status === 2">关闭</el-tag>
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" fixed="right">
          <template slot-scope="{ row }">
            <el-row class="operation-row">
              <el-button
                type="primary"
                size="small"
                @click="openDialog(2, row)"
                style="margin-right: 10px"
                >编辑</el-button
              >
              <!-- <el-button type="danger" size="small" @click="handleDelete(row)"
                >删除表</el-button
              >
              <el-button type="danger" size="small" @click="handleDelete1(row)"
                >删除本行</el-button
              > -->
            </el-row>
            <el-row class="operation-row">
              <el-upload
                accept=".xls,.xlsx"
                :show-file-list="false"
                :on-success="onSuccess"
                :on-error="onError"
                style="display: inline-flex; margin-right: 10px"
                :action="action + '/' + row.id"
                :headers="headers"
              >
                <el-button type="primary" size="small" icon="el-icon-upload2">
                  上传表
                </el-button>
              </el-upload>
              <!-- <el-button
                size="small"
                type="primary"
                icon="el-icon-download"
                @click="handleExport(row)"
              >
                下载表
              </el-button> -->
            </el-row>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        class="underBar"
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page || 1"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <CouponDialog
      v-model="dialogInfos"
      :visible="dialogVisible"
      :type="dialogType"
      @close="dialogVisible = false"
      @refresh="getData()"
    ></CouponDialog>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { getCookie } from '@/utils/cookie'
import CouponDialog from './components/CouponDialog.vue'

export default {
  name: 'vip_card',
  components: {
    CouponDialog
  },
  data() {
    return {
      dialogVisible: false,//用户详情信息显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}coupon_user_import`
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loading = true
      let params = this.query
      getApiData('coupons', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    openDialog(num, val) {
      //打开添加队伍弹窗
      this.dialogVisible = true
      if (num === 1) {
        this.dialogType = 1
        this.dialogInfos = undefined
      }
      if (num === 2) {
        this.dialogType = 2
        this.dialogInfos = JSON.parse(JSON.stringify(val))
      }
    },
    onSuccess(res) {
      //上传文件成功
      this.$message.success("上传成功！");
      this.getData()
    },
    onError(err) {
      this.$message.error("上传失败！");
    },
    // 下载
    handleExport(rowInfo) {
      let params = {
        id: rowInfo.id
      }
      http
        .post(
          api + '',
          { ...params },
          {
            responseType: 'arraybuffer'
          }
        )
        .then(res => {
          saveFile(res, {
            type:
              'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '用户表单.xlsx'
          })
        }).finally(() => {
        })
    },
    handleDelete(rowInfo) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`/${rowInfo.id}`).then((res) => {
          if (res.code) {
            this.$message.success(res.message)
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    handleDelete1(rowInfo) {
      //删除
      this.$confirm('确定要删除吗？', {
        type: 'warning'
      }).then(res => {
        delApiData(`/${rowInfo.id}`).then((res) => {
          if (res.code) {
            this.$message.success(res.message)
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.coupon-box {
  header {
  }

  .body-box {
  }
}
</style>